<template>
    <header class="main">
        <div class="main-title">
            <img class="back-arrow" src="../assets/icon_back.svg" alt="">
            <div class="main-title__img">
                <img src="../assets/avatar.jpg" alt="">
            </div>

            <div class="main-title__name">
                <p>{{userName}}</p>
                <p>Online</p>
            </div>

            <div class="main-title__online">
                <img src="../assets/icon_call.svg" alt="">
                <img src="../assets/icon_info.svg" alt="">
            </div>
        </div>
    </header>
</template>

<script>
    export default {
        props: ['userName']
    }
</script>

<style lang="scss">

    .main {
        /*max-width: 297px;*/
        margin: 0 auto;
        position: fixed;
        width: 100%;
        z-index: 1;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
        background: white;
        padding: 0 11px;

        &-title {
            padding: 12px 0;
            border-bottom: solid rgba(254, 254, 254, 0.2) 1px;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: flex-end;
            max-width: 345px;
            margin: 0 auto;

            .back-arrow {
                align-self: center;
            }

            &__img {
                width: 33px;
                height: 33px;
                position: relative;
                margin-left: 12px;

                &::after {
                    content: '';
                    width: 8px;
                    height: 8px;
                    background: #39D739;
                    border: 1px solid #FFFFFF;
                    border-radius: 50px;
                    position: absolute;
                    bottom: 0;
                    left: 23px;
                }

                img {

                    &:last-child {
                        clip-path: circle(16.5px at 50% 50%);
                        max-width: 100%;
                    }
                }
            }

            p {
                font: bold 16px /19px Roboto;
                letter-spacing: 0.05em;

                &:nth-of-type(2) {
                    font: 300 12px/14px Roboto;
                    margin-top: 5px;
                    color: #5B5B5B;
                }
            }

            &__online {
                img {
                    &:first-child {
                        margin-right: 23px;
                    }
                }

            }

            &__name {
                flex-grow: 1;
                margin-left: 10px;
            }
        }
    }

</style>